module.exports = __webpack_public_path__ + "img/closePro.c824acd7.png";